<template>
  <div class="col-md-3 col-sm-12 col-xs-12">
    {{ titulo }}
    <q-select
      dense
      outlined
      use-input
      hide-selected
      fill-input
      input-debounce="0"
      hint="Digite 3 caracteres para filtrar"
      @filter="filterFn"
      v-model="fornecedor"
      nome="nome"
      :option-label="
        (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
      "
      :options="listaFornecedores"
    >
    </q-select>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    titulo: {
      type: String,
      default: "Selecione o Fornecedor",
    },
    id: {
      type: String,
    },
    model: {
      type: Object,
      default: () => {},
    },
    reset: {
      type: Number,
    },
  },
  name: "SelectComponentFornecedores",
  emits: ["emitirFornecedor"],

  setup(props, { emit }) {
    const fornecedor = ref({
      id: "",
      nome: "",
      fantasia: "",
      cnpj: "",
    });
    const time = ref();
    const paginacao = ref({
      page: 1,
      rowsPerPage: 100,
    });

    const verificarFornecedor = () => {
      if (props.model != null && props.model != undefined) {
        fornecedor.value = props.model;
      }
    };

    watch(fornecedor, () => {
      if (props.model != null && props.model != undefined) {
        return;
      }
      emitirFornecedor(fornecedor);
    });

    watch(
      () => props.model,
      () => {
        fornecedor.value = props.model;
      }
    );

    watch(
      () => props.reset,
      () => {
        fornecedor.value = {
          id: "",
          nome: "",
          fantasia: "",
          cnpj: "",
        };
      }
    );

    let emitirFornecedor = async (emitirFornecedor) => {
      emit("emitirFornecedor", emitirFornecedor);
    };

    const store = useStore();
    const listaFornecedores = ref([]);

    let listarFornecedores = async (search) => {
      try {
        let resposta = await store.dispatch("fer/listarFornecedores", {
          paginacao: paginacao.value,
          search,
        });

        listaFornecedores.value = resposta.listaFornecedores;
      } catch (error) {
        console.error(error);
      }
    };

    let consultarFornecedor = async () => {
      let resposta = await store.dispatch("fer/consultarFornecedor", {
        id: props.id,
      });
      fornecedor.value = resposta.fornecedor;
    };

    onMounted(verificarFornecedor);

    return {
      listaFornecedores,
      fornecedor,
      verificarFornecedor,
      emitirFornecedor,
      paginacao,
      consultarFornecedor,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarFornecedores(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>
